import { render, staticRenderFns } from "./gs.vue?vue&type=template&id=353d1c84"
import script from "./gs.vue?vue&type=script&lang=js"
export * from "./gs.vue?vue&type=script&lang=js"
import style0 from "./gs.vue?vue&type=style&index=0&id=353d1c84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports